module.exports = __webpack_public_path__ + "img/zhongYao6.bfb1fa9f.png";